import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'

// TossPixel 타입 선언
declare global {
  interface Window {
    TossPixel: any
    gtag: any
  }
}

export default function EventTracker() {
  const location = useLocation()

  useEffect(() => {
    // Meta Pixel 페이지뷰
    ReactPixel.pageView()

    // Google Analytics 페이지뷰
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-S3RKT5GVN6', {
        page_path: location.pathname + location.search
      })
    }

    // TossPixel 페이지뷰
    const tossPixelKey = process.env.REACT_APP_TOSS_PIXEL_KEY
    if (tossPixelKey && window.TossPixel) {
      try {
        new window.TossPixel(tossPixelKey).pageView()
      } catch (error) {
        console.error('TossPixel pageView failed:', error)
      }
    }
  }, [location])

  return <div />
}
